import React from "react";

export default function ProgressBar({ page }) {
  return (
    <div>
      <div className="text-center">
        <ul id="progressbar">
          {/* <li className={page === "bvn" ? "active" : null}>BVN VALIDATION</li> */}
          <li className={`${page === "basicInfo" ? "active" : null} bar`}>
          BASIC INFORMATION
          </li>
          <li className={`${page === "identityValidation" ? "active" : null} bar`}>
          ID VALIDATION
          </li>
          <li className={`${page === "docs" ? "active" : null} bar` }>
            DOCUMENT INFORMATION
          </li>
        </ul>
      </div>
    </div>
  );
}
